import {
    addDoc,
    collection,
    doc,
    getDoc,
    getDocs,
    query,
    setDoc,
    where,
    orderBy,
    limit
} from "firebase/firestore";
import {fireStoreDB} from "../../firebase/client-app";
import {Promise} from "bluebird";
import _ from "lodash";
import {DATA_LIMIT} from "../constants/facebook-constant";

export {
    addTargetingInterests,
    addSingleTargetingInterest,
    updateSingleTargetingInterest,
    getSingleTargetingInterest,
    getAllTargetingInterests,
    searchTargetingInterests,
    searchTargetingInterestsWithSearchCriteria,
    prepareTargetingInterestsList
}

const collectionName = 'facebook-targeting-interests';
const collectionReference = collection(fireStoreDB, collectionName);

const addTargetingInterests = (targetingInterests) => {
    return Promise.map(targetingInterests, async targetingInterest => {
        await addSingleTargetingInterest(targetingInterest);
    });
}

const addSingleTargetingInterest = (targetingInterest) => {
    targetingInterest.createdAt = new Date();
    targetingInterest.updatedAt = targetingInterest.createdAt;
    return addDoc(collectionReference, targetingInterest);
}

const updateSingleTargetingInterest = (targetingInterest) => {
    const documentReference = doc(fireStoreDB, collectionName, targetingInterest.id);
    targetingInterest.updatedAt = new Date();
    return setDoc(documentReference, targetingInterest);
}

const getSingleTargetingInterest = async (targetingInterestId) => {
    const documentReference = doc(fireStoreDB, collectionName, targetingInterestId);
    const targetingInterestDoc = await getDoc(documentReference);
    return prepareSingleTargetingInterest(targetingInterestDoc);
}

const getAllTargetingInterests = async () => {
    let searchQuery = query(collectionReference);
    const targetingInterestsResult = await getDocs(searchQuery);
    return prepareTargetingInterestsList(targetingInterestsResult);
}

const searchTargetingInterests = async (searchText, perPage = DATA_LIMIT) => {
    let searchQuery = query(collectionReference);

    if (searchText) {
        searchQuery = query(collectionReference, where("textList", "array-contains", searchText));
    }

    searchQuery = query(searchQuery,
        orderBy('updatedAt', 'desc'));

    searchQuery = query(searchQuery, limit(perPage));

    const targetingInterestResult = await getDocs(searchQuery);
    return prepareTargetingInterestsList(targetingInterestResult);
}

const searchTargetingInterestsWithSearchCriteria = async (searchCriteriaList, perPage = DATA_LIMIT) => {
    let searchQuery = query(collectionReference);

    // console.log('searchTargetingInterestsWithSearchCriteria', {searchCriteriaList});

    _.forEach(searchCriteriaList, searchCriteria => {
        searchQuery = query(searchQuery,
            where(searchCriteria.field, searchCriteria.condition, searchCriteria.value));
    });

    /*if (searchCriteriaList.length === 0) {
        searchQuery = query(searchQuery, orderBy('updatedAt', 'desc'));
    }*/

    searchQuery = query(searchQuery, limit(perPage));

    const targetingInterestResult = await getDocs(searchQuery);
    return prepareTargetingInterestsList(targetingInterestResult);
}

const prepareTargetingInterestsList = (targetingInterestResult) => {
    const targetingInterestsList = [];

    _.forEach(targetingInterestResult.docs, targetingInterestDoc => {
        targetingInterestsList.push(prepareSingleTargetingInterest(targetingInterestDoc));
    });

    return targetingInterestsList;
}


const prepareSingleTargetingInterest = (targetingInterestDoc) => {
    const targetingInterest = targetingInterestDoc.data();
    targetingInterest.id = targetingInterestDoc.id;
    return targetingInterest;
}
